import React, { useState, useEffect } from 'react';

const BytesToPdf = ({ pdfByteArray }) => {
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    if (pdfByteArray && pdfByteArray.length > 0) {
      const uint8Array = new Uint8Array(pdfByteArray);
      const blob = new Blob([uint8Array], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);

      return () => URL.revokeObjectURL(url);
    }
  }, [pdfByteArray]);

  return (
    <div>
      {pdfUrl ? (
        <iframe title="PDF Viewer" src={pdfUrl} width="100%" height="600px" />
      ) : (
        <div>Error</div>
      )}
    </div>
  );
};

export default BytesToPdf;
